// // import React, { useContext, useState, useEffect } from "react";
// // import ConversationList from "./ConversationList";
// // import ChatRoom from "./ChatRoom";
// // import { Box, Grid } from "@mui/material";
// // import "./ChatRoom.scss"; // Ensure this is imported to apply styles
// // import { useParams, useNavigate,useLocation } from "react-router-dom";
// // import { AuthContext } from "../../login/AuthContext";
// // import translations from '../../../utils/language/translations.json';
// // import { useTranslation } from 'react-i18next';
// // import { hasConsent } from "../../login/hasConsent";
// // import SeoHelmet from '../../../Seo/SeoHelmet';

// // const FullMessage = () => {
// //   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
// //   const currentLang = i18n.language; // Access the current language
// //   const t = (key) => translations.Message[key][currentLang]; // Adjust the path according to your JSON structure

// //   const { userId, loading } = useContext(AuthContext);
// //   const [showChatView, setShowChatView] = useState(false);
// //   const [conversations, setConversations] = useState([]);
// //   const [selectedConversation, setSelectedConversation] = useState(null);
// //   const { targetUserId } = useParams();
 
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const prefillMessage = location.state?.prefillMessage || "";
// //   console.log('prefillMessage',prefillMessage)
// //   const [isMobile, setIsMobile] = useState(false);

  
// //   useEffect(() => {
// //     if (!loading && !userId) {
// //       if (hasConsent()) {
// //       localStorage.setItem('intendedPath', window.location.pathname + window.location.search);}
// //      navigate(i18n.language === 'fr' ? `/fr/login`:`/login`)
     
       
// //     }
// //   }, [loading, userId, navigate]);

// //   useEffect(() => {
// //     if (!loading && userId && conversations?.length===0) {
// //       const fetchConversations = async () => {
// //         const response = await fetch(
// //           `${process.env.REACT_APP_API_BASE}/users/${userId}/conversations`,
// //           { credentials: 'include' } // Include credentials for cookies
// //         );
// //         const data = await response.json();
// //         setConversations(data);
// //         console.log('je trigger 45')
// //         if (targetUserId) {
// //           const targetConversation = data.find(
// //             (convo) => parseInt(convo.UserId) === parseInt(targetUserId)
// //           );
// //           if (targetConversation) {
// //             setSelectedConversation(targetConversation);
// //           } else {
// //             console.log('userId, target avant start new conv', userId, targetUserId);
// //             startNewConversation(userId, targetUserId);
// //           }
// //         }
// //       };

// //       fetchConversations();
// //     }
// //     console.log('je trigger 61')
// //   }, [userId, targetUserId, loading]);


  
// //   useEffect(() => {
// //     const handleResize = () => {
// //       setIsMobile(window.innerWidth <= 768);
// //     };
  
// //     handleResize();
// //     window.addEventListener("resize", handleResize);
// //     return () => window.removeEventListener("resize", handleResize);
// //   }, []);

// //   const handleSelectConversation = (convo) => {
// //     setSelectedConversation(convo);
// //     if (isMobile) setShowChatView(true); // On mobile, show only the chat
// //   };



// //   const SelectConversation = (conversation) => {
// //     setSelectedConversation(conversation);
// //   };

// //   const startNewConversation = async (userId, targetUserId) => {
// //     const response = await fetch(
// //       `${process.env.REACT_APP_API_BASE}/messages/first-time/${targetUserId}`,
// //       { credentials: 'include' } // Include credentials for cookies
// //     );
// //     const { isFirstTime } = await response.json();

// //     console.log('userId, targetUserId', userId, targetUserId);
// //     console.log("starting new conversation 59");
// //     console.log('isFirstTime', isFirstTime);

// //     if (isFirstTime) {
// //       console.log("Starting first-time conversation");
// //       // Initialize a conversation by creating a placeholder
// //       await fetch("https://projet-collect-v1-production.up.railway.app/start-conversation", {
// //         method: "POST",
// //         headers: {
// //           "Content-Type": "application/json",
// //         },
// //         body: JSON.stringify({
// //           SenderId: userId,
// //           RecipientId: targetUserId,
// //         }),
// //         credentials: 'include' // Include credentials for cookies
// //       });

// //       // Refresh the conversation list after creating a new one
// //       const newResponse = await fetch(
// //         `${process.env.REACT_APP_API_BASE}/users/${userId}/conversations`,
// //         { credentials: 'include' } // Include credentials for cookies
// //       );
// //       const newData = await newResponse.json();
// //       setConversations(newData);
// //       const newConversation = newData.find(
// //         (convo) => convo.UserId === parseInt(targetUserId)
// //       );
// //       if (newConversation) {
// //         setSelectedConversation(newConversation);
// //       }
// //     }
// //   };

// //   if (loading) {
// //     return <div>Loading...</div>; // Optional: Show a loading spinner or message
// //   }


// //   return (  
// //     <section className="grid">
// //       <SeoHelmet type="messages" />
// //       <div className="contentfront NoPadding">
// //       <div className='justify top-page'></div>
// //       <Box className="full-message-container">
// //         <Grid container spacing={4}>
// //         {isMobile ? (
// //   showChatView ? (
// //     <ChatRoom
// //       currentUser={userId}
// //       selectedConversation={selectedConversation}
// //       showChatView={showChatView}
// //       setShowChatView={setShowChatView}
// //       isMobile={true}
// //       prefillMessage={prefillMessage}
// //       //conversations={conversations}
// //       // other props
// //     />
// //   ) : (
// //     <ConversationList
// //       conversations={conversations||[]}
// //       selectedConversation={selectedConversation}
// //       onSelectConversation={handleSelectConversation}
// //       isMobile={true}
// //       currentUser={userId}
// //       // other props
// //     />
// //   )
// // ) : (
// //   // Desktop layout
// //   <>
// // <Grid item xs={3}>
// //             <div className="conversation-list">
// //               <ConversationList
// //                 currentUser={userId}
// //                 conversations={conversations||[]}
// //                 onSelectConversation={handleSelectConversation}
// //                 selectedConversation={selectedConversation}
// //               />
// //             </div>
// //           </Grid>
// //           <Grid item xs={7}>
// //             {selectedConversation && (
// //               <ChatRoom
// //                 currentUser={userId}
// //                 selectedConversation={selectedConversation}
// //                 showChatView={showChatView}
// //                 setShowChatView={setShowChatView}
// //                 isMobile={false}
// //                 prefillMessage={prefillMessage}
// //               />
// //             )}
// //           </Grid></>
// // )}
          
// //         </Grid>
// //       </Box>
// //       </div>
// //     </section>
// //   );
// // };

// // export default FullMessage;



// import React, { useContext, useState, useEffect } from "react";
// import { Box, Grid } from "@mui/material";
// import { useParams, useNavigate, useLocation } from "react-router-dom";

// import ConversationList from "./ConversationList";
// import ChatRoom from "./ChatRoom";
// import "./ChatRoom.scss";

// import { AuthContext } from "../../login/AuthContext";
// import translations from "../../../utils/language/translations.json";
// import { useTranslation } from "react-i18next";
// import { hasConsent } from "../../login/hasConsent";
// import SeoHelmet from "../../../Seo/SeoHelmet";

// const FullMessage = () => {
//   // i18n
//   const { t: tRaw, i18n } = useTranslation();
//   const currentLang = i18n.language;
//   const t = (key) =>
//     (translations?.Message?.[key]?.[currentLang]) ?? tRaw(key) ?? key;

//   // auth
//   const { userId, loading } = useContext(AuthContext);

//   // route params / nav
//   const { targetUserId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const prefillMessage = location.state?.prefillMessage || "";

//   // ui state
//   const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
//   const [showChatView, setShowChatView] = useState(false);

//   // data state
//   const [conversations, setConversations] = useState([]);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [convLoading, setConvLoading] = useState(false);
//   const [convErr, setConvErr] = useState(null);

//   // normalize user id for URLs
//   const userIdNorm =
//     userId && typeof userId === "object"
//       ? userId.id || userId.userId
//       : userId;

//   // redirect unauthenticated users once auth settles
//   useEffect(() => {
//     if (loading) return;
//     if (!userIdNorm) {
//       if (hasConsent()) {
//         localStorage.setItem(
//           "intendedPath",
//           window.location.pathname + window.location.search
//         );
//       }
//       navigate(i18n.language === "fr" ? "/fr/login" : "/login", { replace: true });
//     }
//   }, [loading, userIdNorm, navigate, i18n.language]);

//   // responsive
//   useEffect(() => {
//     const onResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   // fetch conversations + select target (or first)
//   useEffect(() => {
//     if (loading || !userIdNorm) return;

//     let cancel = false;
//     (async () => {
//       try {
//         setConvLoading(true);
//         setConvErr(null);

//         const res = await fetch(
//           `${process.env.REACT_APP_API_BASE}/users/${encodeURIComponent(
//             userIdNorm
//           )}/conversations`,
//           { credentials: "include" }
//         );
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const data = await res.json();
//         if (cancel) return;

//         const list = Array.isArray(data) ? data : [];
//         setConversations(list);

//         // If a target is provided, select it or create it; else select the first
//         if (targetUserId) {
//           const target = list.find(
//             (c) => parseInt(c.UserId, 10) === parseInt(targetUserId, 10)
//           );
//           if (target) {
//             setSelectedConversation(target);
//           } else {
//             await startNewConversation(userIdNorm, targetUserId);
//           }
//         } else if (!selectedConversation && list.length > 0) {
//           setSelectedConversation(list[0]);
//         }
//       } catch (e) {
//         if (!cancel) setConvErr(e);
//         console.error("fetch conversations failed:", e);
//       } finally {
//         if (!cancel) setConvLoading(false);
//       }
//     })();

//     return () => {
//       cancel = true;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, userIdNorm, targetUserId]);

//   // create a conversation if first-time, then refresh and select it
//   const startNewConversation = async (senderId, targetId) => {
//     try {
//       const firstRes = await fetch(
//         `${process.env.REACT_APP_API_BASE}/messages/first-time/${encodeURIComponent(
//           targetId
//         )}`,
//         { credentials: "include" }
//       );
//       const { isFirstTime } = await firstRes.json();

//       if (isFirstTime) {
//         await fetch(
//           "https://projet-collect-v1-production.up.railway.app/start-conversation",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             credentials: "include",
//             body: JSON.stringify({ SenderId: senderId, RecipientId: targetId }),
//           }
//         );
//       }

//       const refRes = await fetch(
//         `${process.env.REACT_APP_API_BASE}/users/${encodeURIComponent(
//           senderId
//         )}/conversations`,
//         { credentials: "include" }
//       );
//       const list = await refRes.json();
//       const arr = Array.isArray(list) ? list : [];
//       setConversations(arr);

//       const newConvo = arr.find(
//         (c) => parseInt(c.UserId, 10) === parseInt(targetId, 10)
//       );
//       if (newConvo) setSelectedConversation(newConvo);
//     } catch (e) {
//       console.error("startNewConversation failed:", e);
//       setConvErr(e);
//     }
//   };

//   const handleSelectConversation = (convo) => {
//     setSelectedConversation(convo);
//     if (isMobile) setShowChatView(true);
//   };

//   if (loading || !userIdNorm) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <section className="grid">
//       <SeoHelmet type="messages" />
//       <div className="contentfront NoPadding">
//         <div className="justify top-page" />
//         <Box className="full-message-container">
//           <Grid container spacing={4}>
//             {isMobile ? (
//               showChatView ? (
//                 <ChatRoom
//                   currentUser={userIdNorm}
//                   selectedConversation={selectedConversation}
//                   showChatView={showChatView}
//                   setShowChatView={setShowChatView}
//                   isMobile
//                   prefillMessage={prefillMessage}
//                 />
//               ) : (
//                 <ConversationList
//                   conversations={conversations}
//                   selectedConversation={selectedConversation}
//                   onSelectConversation={handleSelectConversation}
//                   isMobile
//                   currentUser={userIdNorm}
//                 />
//               )
//             ) : (
//               <>
//                 <Grid item xs={3}>
//                   {convLoading ? (
//                     <div className="conv-skeleton">Loading…</div>
//                   ) : convErr ? (
//                     <div className="conv-empty">{t("UnableToLoadConversations") || "Unable to load conversations."}</div>
//                   ) : (
//                     <ConversationList
//                       currentUser={userIdNorm}
//                       conversations={conversations}
//                       onSelectConversation={handleSelectConversation}
//                       selectedConversation={selectedConversation}
//                     />
//                   )}
//                 </Grid>

//                 <Grid item xs={7}>
//                   {selectedConversation ? (
//                     <ChatRoom
//                       currentUser={userIdNorm}
//                       selectedConversation={selectedConversation}
//                       showChatView={showChatView}
//                       setShowChatView={setShowChatView}
//                       isMobile={false}
//                       prefillMessage={prefillMessage}
//                     />
//                   ) : (
//                     <div className="conv-empty">
//                       {t("SelectAConversation") || "Select a conversation"}
//                     </div>
//                   )}
//                 </Grid>
//               </>
//             )}
//           </Grid>
//         </Box>
//       </div>
//     </section>
//   );
// };

// export default FullMessage;



import React, { useContext, useState, useEffect, useCallback } from "react";
import { Box, Grid, Button } from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import ConversationList from "./ConversationList";
import ChatRoom from "./ChatRoom";
import "./ChatRoom.scss";

import { AuthContext } from "../../login/AuthContext";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { hasConsent } from "../../login/hasConsent";
import SeoHelmet from "../../../Seo/SeoHelmet";

/** small helper */
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** fetch with retry (2 retries by default) */
async function fetchWithRetry(url, opts, { retries = 2, delay = 700 } = {}) {
  let lastErr;
  for (let i = 0; i <= retries; i++) {
    try {
      const res = await fetch(url, { credentials: "include", ...opts });
      if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`);
        err.status = res.status;
        throw err;
      }
      return await res.json();
    } catch (e) {
      lastErr = e;
      if (i < retries) await sleep(delay);
    }
  }
  throw lastErr;
}

const FullMessage = () => {
  // i18n
  const { t: tRaw, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) =>
    (translations?.Message?.[key]?.[currentLang]) ?? tRaw(key) ?? key;

  // auth
  const { userId, loading,jwtToken,isAuthenticated,liveCsrfToken } = useContext(AuthContext);

  // route params / nav
  const { targetUserId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const prefillMessage = location.state?.prefillMessage || "";

  // ui state
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [showChatView, setShowChatView] = useState(false);

  // data state
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [convLoading, setConvLoading] = useState(false);
  const [convErr, setConvErr] = useState(null);

  // normalize user id for URLs
  const userIdNorm =
    userId && typeof userId === "object" ? userId.id || userId.userId : userId;



  // redirect unauthenticated users once auth settles
  useEffect(() => {
    if (loading) return;

    console.log('userIdNorm',userIdNorm)
    if (!userIdNorm) {
      if (hasConsent()) {
        localStorage.setItem(
          "intendedPath",
          window.location.pathname + window.location.search
        );
      }
      navigate(i18n.language === "fr" ? "/fr/login" : "/login", {
        replace: true,
      });
    }
  }, [loading, userIdNorm, navigate, i18n.language]);

  // responsive
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);




  const loadConversations = useCallback(
    async (opts = { retries: 2, delay: 700 }) => {
      if (!userIdNorm) return;
      setConvLoading(true);
      setConvErr(null);
      try {
        const url = `${process.env.REACT_APP_API_BASE}/users/${encodeURIComponent(
          userIdNorm
        )}/conversations`;
        const data = await fetchWithRetry(url, {}, opts);
        const list = Array.isArray(data) ? data : [];
        setConversations(list);

        // Select target or first
        if (targetUserId) {
          const target = list.find(
            (c) => parseInt(c.UserId, 10) === parseInt(targetUserId, 10)
          );
          if (target) {
            if (!selectedConversation || selectedConversation.UserId !== target.UserId) {
            setSelectedConversation(target);}
            setShowChatView(true)
          } else {
            await startNewConversation(userIdNorm, targetUserId);
          }
        } else if (!selectedConversation && list.length > 0) {
          setSelectedConversation(list[0]);

        }
      } catch (e) {
        // If unauthorized, send to login
        if (e && (e.status === 401 || e.status === 403)) {
          if (hasConsent()) {
            localStorage.setItem(
              "intendedPath",
              window.location.pathname + window.location.search
            );
          }
          navigate(i18n.language === "fr" ? "/fr/login" : "/login", {
            replace: true,
          });
          return;
        }
        setConvErr(e);
        console.error("fetch conversations failed:", e);
      } finally {
        setConvLoading(false);
      }
    },
    [userIdNorm, targetUserId, navigate, i18n.language]
  );

  // initial load on ready
  useEffect(() => {
    if (loading || !userIdNorm) return;
    loadConversations(); // with retries
  }, [loading, userIdNorm, targetUserId]);

  // create a conversation if first-time, then refresh and select it
  const startNewConversation = async (senderId, targetId) => {
    console.log('userIdNorm senderId, targetId',senderId, targetId)
    try {
     const firstURL = `${process.env.REACT_APP_API_BASE}/messages/first-time/${encodeURIComponent(targetId)}`;

const { isFirstTime } = await fetchWithRetry(
  firstURL,
  {
      method: "GET",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${jwtToken}`,
    "X-CSRF-Token": liveCsrfToken,
  },
  },
  { retries: 1, delay: 400 }
);

      if (isFirstTime) {
        await fetchWithRetry(
          `${process.env.REACT_APP_API_BASE}/start-conversation`,
          {
            method: "POST",
        credentials: "include",                     // << add this
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${jwtToken}`,
       "X-CSRF-Token": liveCsrfToken,    // (optional if your server supports JWT)
    },
            body: JSON.stringify({ SenderId: senderId, RecipientId: targetId }),
          },
          { retries: 1, delay: 400 }
        );
      }

      // refresh list and select
      const list = await fetchWithRetry(
        `${process.env.REACT_APP_API_BASE}/users/${encodeURIComponent(
          senderId
        )}/conversations`,
        {},
        { retries: 1, delay: 400 }
      );

      const arr = Array.isArray(list) ? list : [];
      setConversations(arr);

      const newConvo = arr.find(
        (c) => parseInt(c.UserId, 10) === parseInt(targetId, 10)
      );
     if (newConvo && (!selectedConversation || selectedConversation.UserId !== newConvo.UserId)) {
  setSelectedConversation(newConvo);
}
    } catch (e) {
      console.error("startNewConversation failed:", e);
      setConvErr(e);
    }
  };

  const handleSelectConversation = (convo) => {
    setSelectedConversation(convo);
    if (isMobile) setShowChatView(true);
  };

  if (loading || !userIdNorm) {
    return <div className="conv-skeleton">Loading…</div>;
  }

  return (
    <section className="grid">
      <SeoHelmet type="messages" />
      <div className="contentfront NoPadding">
        <div className="justify top-page" />
        <Box className="full-message-container">
          <Grid container spacing={4}>
            {isMobile ? (
              showChatView ? (
                <ChatRoom
                  currentUser={userIdNorm}
                  selectedConversation={selectedConversation}
                  setSelectedConversation={setSelectedConversation}
                  showChatView={showChatView}
                  setShowChatView={setShowChatView}
                  isMobile
                  prefillMessage={prefillMessage}
                />
              ) : (
                <ConversationList
                  conversations={conversations}
                  selectedConversation={selectedConversation}
                  onSelectConversation={handleSelectConversation}
                  isMobile
                  currentUser={userIdNorm}
                />
              )
            ) : (
              <>
                <Grid item xs={3}>
                  {convLoading ? (
                    <div className="conv-skeleton">Loading…</div>
                  ) : convErr ? (
                    <div className="conv-empty">
                      {t("UnableToLoadConversations") ||
                        "Unable to load conversations."}
                      <br />
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => loadConversations({ retries: 2, delay: 700 })}
                        
                      >
                        {t("Retry") || "Retry"}
                      </Button>
                    </div>
                  ) : (
                    <ConversationList
                      currentUser={userIdNorm}
                      conversations={conversations}
                      onSelectConversation={handleSelectConversation}
                      selectedConversation={selectedConversation}
                    />
                  )}
                </Grid>

                <Grid item xs={7}>
                  {selectedConversation ? (
                    <ChatRoom
                      currentUser={userIdNorm}
                      selectedConversation={selectedConversation}
                      setSelectedConversation={setSelectedConversation}
                      showChatView={showChatView}
                      setShowChatView={setShowChatView}
                      isMobile={false}
                      prefillMessage={prefillMessage}
                    />
                  ) : (
                    <div className="conv-empty">
                      {t("SelectAConversation") || "Select a conversation"}
                    </div>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </div>
    </section>
  );
};

export default FullMessage;
